import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    useTheme,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";

import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import CloseIcon from "@mui/icons-material/Close";

const DownloadAppModal = ({ open, onClose }) => {
    const theme = useTheme();

    const [platform, setPlatform] = useState("android");

    // QR Code URLs
    const androidQrUrl =
        "https://ik.imagekit.io/arthgyan/Arthgyan_Web/andriodQr.png";

    const iosQrUrl = "https://ik.imagekit.io/arthgyan/Arthgyan_Web/iOSQr.png";

    const androidPlayStoreUrl =
        "https://play.google.com/store/apps/details?id=com.arthgyan.financemanager";

    const iosAppStoreUrl = "https://apps.apple.com/in/app/arthgyan/id6796249762";

    const isAndroid = platform === "android";

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogContent
                sx={{
                    position: "relative",
                    py: { xs: 4, sm: 5 },
                    px: { xs: 2, sm: 3 },
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: theme.palette.background.paper,
                }}
            >
                {/* Close Button */}
                <IconButton
                    onClick={onClose}
                    aria-label="Close download dialog"
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: theme.palette.text.secondary,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* App Name */}
                <Typography
                    sx={{
                        mb: 2.5,
                        fontSize: 22,
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                        letterSpacing: 0.5,
                    }}
                >
                    Arth
                    <Box
                        component="span"
                        sx={{ color: theme.palette.primary.main }}
                    >
                        Gyan
                    </Box>
                </Typography>

                {/* Android / iOS Toggle */}
                <ToggleButtonGroup
                    value={platform}
                    exclusive
                    onChange={(event, newPlatform) => {
                        if (newPlatform) {
                            setPlatform(newPlatform);
                        }
                    }}
                    aria-label="Select mobile platform"
                    sx={{
                        mb: 3,
                        p: 0.5,
                        borderRadius: "10px",
                        bgcolor: theme.palette.action.hover,
                        "& .MuiToggleButtonGroup-grouped": {
                            border: 0,
                            borderRadius: "8px !important",
                            px: 3,
                            py: 1,
                            textTransform: "none",
                            fontWeight: 600,
                            gap: 0.8,
                        },
                        "& .Mui-selected": {
                            bgcolor: `${theme.palette.primary.main} !important`,
                            color: "#fff !important",
                        },
                    }}
                >
                    <ToggleButton value="android">
                        <AndroidIcon fontSize="small" />
                        Android
                    </ToggleButton>

                    <ToggleButton value="ios">
                        <AppleIcon fontSize="small" />
                        iOS
                    </ToggleButton>
                </ToggleButtonGroup>

                {/* Selected Platform QR Code */}
                <Box
                    component="img"
                    src={isAndroid ? androidQrUrl : iosQrUrl}
                    alt={`${isAndroid ? "Android" : "iOS"} app QR Code`}
                    sx={{
                        width: { xs: 220, sm: 260 },
                        height: { xs: 220, sm: 260 },
                        objectFit: "contain",
                        mb: 3,
                    }}
                />

                {/* Download Button */}
                <Button
                    variant="contained"
                    startIcon={
                        isAndroid ? <AndroidIcon /> : <AppleIcon />
                    }
                    href={
                        isAndroid
                            ? androidPlayStoreUrl
                            : iosAppStoreUrl
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        px: 3,
                        py: 1,
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: "#0080a7",
                        color: "#fff",
                        textTransform: "none",
                        boxShadow: `0 6px 18px ${theme.palette.primary.main}55`,
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                        },
                    }}
                >
                    {isAndroid
                        ? "Get on Play Store"
                        : "Download on App Store"}
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default DownloadAppModal;

